import { Pipe, PipeTransform } from '@angular/core';
import { DeviceType } from '../../afb-api/enums/device-type.enum';

import * as d3 from 'd3';

@Pipe({
  name: 'sensorCondition'
})
export class SensorConditionPipe implements PipeTransform {

  transform(value: number, deviceType: DeviceType, sensorType: string): string {
    if (deviceType != null && sensorType != null && !isNaN(value)) {
      const conditionMap = this.isAwairGlow(deviceType) ?
        this.getAwairGlowConditionThreshold(sensorType) : this.getOmniMintConditionThreshold(sensorType);
      return conditionMap(value) != null ? conditionMap(value) : null;
    } else {
      return null;
    }
  }

  isAwairGlow(deviceType: DeviceType): boolean {
    return (deviceType === DeviceType.Awair || deviceType === DeviceType.Glow)
  }

  private getAwairGlowConditionThreshold(sensorType: string): any {
    const scaleList = {
      'score': {
        // [0 <= x < 60], [60 <= x < 80], [80<= x <= 100]
        'domain': [1, 60, 80, 101],
        'range': ['disconnected', /*'#E73740'*/'poor', /*'#F9A91B'*/'fair', /*'#4FCC53'*/'good']
      },
      'temp': {
        // x < 13, [13 =< x < 16], [16 =< x < 19], [19 =< x < 22], [22 =< x < 26], [26 =< x < 28], [28 =< x < 30], [30 =< x < 32], 32 =< x
        'domain': [13, 16, 19, 22, 26, 28, 30, 32, Infinity],
        'range': [/*'#E73740'*/'poor', /*'#F78725'*/'fair', /*'#F9A91B'*/'fair', /*'#FCD03D'*/'fair',
        /*'#4FCC53'*/'good', /*'#FCD03D'*/'fair', /*'#F9A91B'*/'fair', /*'#F78725'*/'fair', /*'#E73740'*/'poor']
      },
      'humid': {
        // x < 15, [15 =< x < 20], [20 =< x < 35], [35 =< x < 40], [40 =< x < 50], [50 =< x < 60], [60 =< x < 65], [65 =< x < 80], 80 =< x
        'domain': [15, 20, 35, 40, 50, 60, 65, 80, Infinity],
        'range': [/*'#E73740'*/'poor', /*'#F78725'*/'fair', /*'#F9A91B'*/'fair', /*'#FCD03D'*/'fair',
        /*'#4FCC53'*/'good', /*'#FCD03D'*/'fair', /*'#F9A91B'*/'fair', /*'#F78725'*/'fair', /*'#E73740'*/'poor']
      },
      'co2': {
        // x < 1000, [1000 <= x < 1500], [1500 <= x < 2000], [2000 <= x < 3000], 3000 =< x
        'domain': [1000, 1500, 2000, 3000, Infinity],
        'range': [/*'#4FCC53'*/'good', /*'#FCD03D'*/'fair', /*'#F9A91B'*/'fair', /*'#F78725'*/'fair', /*'#E73740'*/'poor']
      },
      'voc': {
        // x < 345, [345 <= x < 849], [849 <= x < 1200], [1200 <= x < 1487], 1487 =< x
        'domain': [345, 849, 1200, 1487, Infinity],
        'range': [/*'#4FCC53'*/'good', /*'#FCD03D'*/'fair', /*'#F9A91B'*/'fair', /*'#F78725'*/'fair', /*'#E73740'*/'poor']
      },
      'dust': {
        // x < 7.49, [7.49 <= x < 22.46], [22.46 <= x < 37.43], [37.43 <= x < 52.4], 52.4 =< x
        'domain': [7.49, 22.46, 37.43, 52.4, Infinity],
        'range': [/*'#4FCC53'*/'good', /*'#FCD03D'*/'fair', /*'#F9A91B'*/'fair', /*'#F78725'*/'fair', /*'#E73740'*/'poor']
      },
      'pm25': {
        'domain': [15, 35, 55, 75, Infinity],
        'range': [/*'#4FCC53'*/'good', /*'#FCD03D'*/'fair', /*'#F9A91B'*/'fair', /*'#F78725'*/'fair', /*'#E73740'*/'poor']
      }
      // gray '#D2D6DE',
    };

    return d3.scaleThreshold()
      .domain(scaleList[sensorType].domain)
      .range(scaleList[sensorType].range);
  }

  // Score & Index Range
  // https://bitfinder.atlassian.net/wiki/spaces/PROD/pages/250019883/Score+Index
  getOmniMintConditionThreshold(sensorType: string): any {
    const scaleList = {
      'score': {
        // [0 <= x < 60], [60 <= x < 80], [80<= x <= 100]
        'domain': [1, 60, 80, 101],
        'range': ['disconnected', /*'#E73740'*/'poor', /*'#F9A91B'*/'fair', /*'#4FCC53'*/'good']
      },
      'temp': {
        // x < 13, [13 =< x < 16], [16 =< x < 19], [19 =< x < 22], [22 =< x < 26], [26 =< x < 28], [28 =< x < 30], [30 =< x < 32], 32 =< x
        'domain': [13, 16, 19, 22, 26, 28, 30, 32, Infinity],
        'range': [/*'#E73740'*/'poor', /*'#F78725'*/'fair', /*'#F9A91B'*/'fair', /*'#FCD03D'*/'fair',
        /*'#4FCC53'*/'good', /*'#FCD03D'*/'fair', /*'#F9A91B'*/'fair', /*'#F78725'*/'fair', /*'#E73740'*/'poor']
      },
      'humid': {
        // x < 15, [15 =< x < 20], [20 =< x < 35], [35 =< x < 40], [40 =< x < 50], [50 =< x < 60], [60 =< x < 65], [65 =< x < 80], 80 =< x
        'domain': [15, 20, 35, 40, 50, 60, 65, 80, Infinity],
        'range': [/*'#E73740'*/'poor', /*'#F78725'*/'fair', /*'#F9A91B'*/'fair', /*'#FCD03D'*/'fair',
        /*'#4FCC53'*/'good', /*'#FCD03D'*/'fair', /*'#F9A91B'*/'fair', /*'#F78725'*/'fair', /*'#E73740'*/'poor']
      },
      'co2': {
        // x < 1000, [1000 <= x < 1500], [1500 <= x < 2000], [2000 <= x < 3000], 3000 =< x
        'domain': [600, 1000, 1500, 2500, Infinity],
        'range': [/*'#4FCC53'*/'good', /*'#FCD03D'*/'fair', /*'#F9A91B'*/'fair', /*'#F78725'*/'fair', /*'#E73740'*/'poor']
      },
      'voc': {
        // x < 345, [345 <= x < 849], [849 <= x < 1200], [1200 <= x < 1487], 1487 =< x
        'domain': [65, 200, 660, 2200, Infinity],
        'range': [/*'#4FCC53'*/'good', /*'#FCD03D'*/'fair', /*'#F9A91B'*/'fair', /*'#F78725'*/'fair', /*'#E73740'*/'poor']
      },
      // 'dust': {
      //   // x < 7.49, [7.49 <= x < 22.46], [22.46 <= x < 37.43], [37.43 <= x < 52.4], 52.4 =< x
      //   'domain': [7.49, 22.46, 37.43, 52.4, Infinity],
      //   'range': [/*'#4FCC53'*/'good', /*'#FCD03D'*/'fair', /*'#F9A91B'*/'fair', /*'#F78725'*/'fair', /*'#E73740'*/'poor']
      // },
      'pm25': {
        'domain': [15, 35, 55, 75, Infinity],
        'range': [/*'#4FCC53'*/'good', /*'#FCD03D'*/'fair', /*'#F9A91B'*/'fair', /*'#F78725'*/'fair', /*'#E73740'*/'poor']
      }
      // gray '#D2D6DE',
    };

    return d3.scaleThreshold()
      .domain(scaleList[sensorType].domain)
      .range(scaleList[sensorType].range);
  }
}
